import { PricePlanTypeEnum } from '@systemeio/types'
import { centsToUnits } from '@systemeio/util'
import SubscriptionDescription from 'modules/funnels/funnel/components/sales-tab/components/subscription-description'
import { FunnelSalesInterface } from 'modules/funnels/funnel/components/sales-tab/types/funnel-sales-interface'
import { UserInterface } from 'shared/types/user-interface'
import { currencyFormat } from 'shared/utils/currency-format'

export const getSalePriceDescription = (
  sale: FunnelSalesInterface,
  user: UserInterface | undefined,
) => {
  if (sale.productOrderItem) {
    return (
      <div className="flex flex-col gap-1">
        <div>
          {currencyFormat(
            centsToUnits(sale.calculatedPrice),
            sale.productOrderItem.product.currency,
            user?.dashboardLocale,
          )}
        </div>
        <div>{sale.productOrderItem.product.name}</div>
      </div>
    )
  } else {
    switch (sale.pricePlan.type) {
      case PricePlanTypeEnum.one_shot:
        return (
          <div>
            {currencyFormat(
              centsToUnits(sale.calculatedPrice),
              sale.pricePlan.currency,
              user?.dashboardLocale,
            )}
          </div>
        )
      case PricePlanTypeEnum.subscription:
      case PricePlanTypeEnum.limited_subscription: {
        return (
          <SubscriptionDescription
            amountWithCurrency={currencyFormat(
              centsToUnits(sale.calculatedPrice),
              sale.pricePlan.currency,
              user?.dashboardLocale,
            )}
            quantity={sale.quantity}
            coupon={sale.coupon}
            subscriptionPricePlan={sale.pricePlan}
          />
        )
      }
      default:
        return <></>
    }
  }
}
